export default "__VITE_ASSET__CYZE6pEq__"